export const getTrackingUrl = (shipper: string, tracking: string) => {
    switch (shipper) {
        case 'UPS':
            return `https://www.ups.com/track?loc=cs_CZ&tracknum=${tracking}`;
        case 'GLS':
            return `https://gls-group.eu/CZ/cs/sledovani-zasilek?match=${tracking}`;
        case 'GLSSK':
            return `https://gls-group.com/SK/sk/sledovanie-zasielok/?match=${tracking}`;
        case 'CP':
            return `https://www.postaonline.cz/trackandtrace/-/zasilka/cislo?parcelNumbers=${tracking}`;
        case 'zasilkovna':
            return `https://www.zasilkovna.cz/vyhledavani?det=${tracking}`;
        case 'PCKT_EXTERNAL':
            return `https://www.zasilkovna.cz/vyhledavani?det=${tracking}`;
        case 'PPL':
            return `https://www.ppl.cz/main2.aspx?cls=Package&idSearch=${tracking}`;
        case 'DHL':
            return `https://www.dhl.com/cz-en/home/tracking/tracking-express.html?submit=1&tracking-id=${tracking}`;
        case 'DPD':
            return `https://www.dpdgroup.com/cz/mydpd/my-parcels/incoming?parcelNumber=${tracking}`;
        case 'PBH':
            return `https://tracking.postabezhranic.cz/detail-${tracking}`;
        case 'GEIS':
            return `https://www.geis-group.cz/cs/sledovani-zasilek?number=${tracking}`;
        default:
            return '';
    }
};
